/**
 * [AI GENERATED CODE]
 * Reducer for managing feature properties from the backend.
 * Stores feature properties as a map keyed by code.
 * enabled: true means feature is globally enabled, false means it's disabled (kill-switch).
 */

const INITIAL_STATE: Record<string, { enabled: boolean }> = {};

export const featureProperties = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case 'SET_FEATURE_PROPERTIES':
      return action.payload || state;
    default:
      return state;
  }
};
